// @ts-check
import { Box, Flex, Label, TickIcon } from '~/design-system';
import React from 'react';

export function ProgressIndicator({
  vertical = false,
  currentIndex,
  spaceEqually = false,
  children,
  ...rest
}) {
  const steps = React.Children.toArray(children);
  const totalStepCount = steps.length;
  return (
    <Flex
      sx={{ justifyContent: 'space-between', marginBottom: 5, width: '100%' }}
      {...rest}
    >
      {steps.map((child, index) => {
        const isBeforeActive = currentIndex >= index;
        const isBallActive = currentIndex >= index;
        const isAfterActive = currentIndex > index;
        const isPrevious = currentIndex > index;
        return (
          <Box
            // @ts-ignore key exists on children returned from Children.toArray.
            key={child.key}
            sx={{
              flexBasis: '100%',
              flexGrow: 1,
            }}
          >
            <Flex
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 1,
                width: '100%',
                '&::before': {
                  content: `''`,
                  ...(index > 0 && {
                    borderTop: '2px solid ',
                    borderTopColor: (theme) =>
                      isBeforeActive
                        ? `${theme.colors?.primary}`
                        : `${theme.colors?.border}`,
                  }),
                  position: 'relative',
                  width: '100%',
                  flex: '1 1 100%',
                  display: 'inline-block',
                  boxSizing: 'border-box',
                },
                '&::after': {
                  content: `''`,
                  ...(index < totalStepCount - 1 && {
                    borderTop: '2px solid ',
                    borderTopColor: (theme) =>
                      isAfterActive
                        ? `${theme.colors?.primary}`
                        : `${theme.colors?.border}`,
                  }),
                  position: 'relative',
                  width: '100%',
                  flex: '1 1 100%',
                  display: 'inline-block',
                  boxSizing: 'border-box',
                },
              }}
            >
              {isPrevious ? (
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 20,
                    height: 20,
                    marginTop: '1px',
                    borderRadius: 15,
                    backgroundColor: (theme) => `${theme.colors?.primary}`,
                    border: `2px solid`,
                    borderColor: (theme) => `${theme.colors?.primary}`,
                  }}
                >
                  <TickIcon
                    size="xxsmall"
                    sx={{
                      color: (theme) => `${theme.colors?.white}`,
                      marginTop: '-12px',
                    }}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    flexShrink: 0,
                    width: 20,
                    height: 20,
                    marginTop: '1px',
                    borderRadius: 15,
                    backgroundColor: (theme) => `${theme.colors?.white}`,
                    border: `2px solid`,
                    borderColor: (theme) =>
                      isBallActive
                        ? `${theme.colors?.primary}`
                        : `${theme.colors?.border}`,
                  }}
                ></Box>
              )}
            </Flex>
            <Box>{child}</Box>
          </Box>
        );
      })}
    </Flex>
  );
}

export function ProgressStep({ children }) {
  return (
    <Box>
      <Label variant="default">{children}</Label>
    </Box>
  );
}
